class Cache{
  constructor(){
    this.ports = {};
    this.connections = {};
  }
}
export default Cache
